export enum UserType {
  VISITOR = 'visitor',
  ONLINE_USER = 'online_user',
  SUPER_ADMIN = 'superAdmin',
  PROPERTY_MANAGER = 'propertyManager',
  GUEST = 'guest',
  ADMIN = 'admin',
  LANDLORD = 'landlord',
  PARTNER_MANAGER = 'partnerManager',
  RESERVATION_MANAGER = 'reservationManager',
  RESERVATION_AGENT = 'reservationAgent',
  HOSPITALITY_MANAGER = 'hospitalityManager',
  RESERVATIONS = 'reservations',
  HOSPITALITY_AGENT = 'hospitalityAgent',
  GES = 'ges',
  SALES_PERSON = 'salesPerson',
  INVESTOR = 'investor',
  DESIGN_TEAM = 'designTeam',
  DESIGN_MANAGER = 'designManager',
  SALES_MANAGER = 'salesManager',
  SALES_SPECIALIST = 'salesSpecialist'
}
